if (!customElements.get("bundle-swiper")) {
  customElements.define(
    "bundle-swiper",
    class extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.swiperEl = this.querySelector(".swiper");
        this.slidesPerView = this.getAttribute("slides-per-view") || 3;
        this.spaceBetween = this.getAttribute("space-between") || 36;
        this.showNavigation = this.getAttribute("show-navigation") || false;
        this.showPagination = this.getAttribute("show-pagination") || false;
        this.paginationEl = this.querySelector(".swiper-pagination");
        this.prevEl = this.querySelector(".swiper-button-prev");
        this.nextEl = this.querySelector(".swiper-button-next");
        this.swiper = new Swiper(this.swiperEl, {
          slidesPerView: 1.3,
          spaceBetween: 10,
          pagination: {
            el: this.paginationEl,
            clickable: true,
          },
          navigation: {
            nextEl: this.nextEl,
            prevEl: this.prevEl,
          },
          breakpoints: {
            751: {
              slidesPerView: this.slidesPerView,
              spaceBetween: this.spaceBetween,
            },
          },
        });
      }
      disconnectedCallback() {}
    }
  );
}
